import React, { useContext, useState } from 'react'

const ProductContext = React.createContext()

export const ProductProvider = ({ children }) => {
  const [product, setProduct] = useState()

  return (
    <ProductContext.Provider value={{ product, setProduct }}>
      {children}
    </ProductContext.Provider>
  )
}

export const useProduct = () => {
  const { product, setProduct } = useContext(ProductContext)
  return { product, setProduct }
}